import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import type { TypeCardSectionSkeleton } from "@/types/contentful/generated";
import CardRow from "./CardRow";
type CardSectionFields = Entry<TypeCardSectionSkeleton, undefined, string>["fields"];
interface Props {
  fields: CardSectionFields;
}
export function CardRowView(t0) {
  const $ = _c(3);
  const {
    fields
  } = t0;
  let t1;
  if ($[0] !== fields.heading || $[1] !== fields.items) {
    t1 = <CardRow items={fields.items} heading={fields.heading} />;
    $[0] = fields.heading;
    $[1] = fields.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}